import { z } from 'zod/v3';

export const linkItemSchema = z.object({
  title: z.string().optional(),
  url: z.string(),
});

export const linksListValueSchema = z.array(linkItemSchema);

export const linksListUiOptionsSchema = z.object({});

export type LinkItem = z.infer<typeof linkItemSchema>;
export type LinksListValue = z.infer<typeof linksListValueSchema>;
export type LinksListUiOptions = z.infer<typeof linksListUiOptionsSchema>;
